import { render, staticRenderFns } from "./NoPatients.vue?vue&type=template&id=7e1c3b5e&"
import script from "./NoPatients.vue?vue&type=script&lang=js&"
export * from "./NoPatients.vue?vue&type=script&lang=js&"
import style0 from "./NoPatients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports